import { Box, Button, FormControl, FormLabel, Tooltip } from '@mui/material';
import { FC } from 'react';
import { t } from 'i18next';
import Iconify from '../iconify';

interface IconDisplayProps {
  isReadOnly: boolean;
  onClick?: () => void;
  iconImage: string | null;
  label?: string;
  isCustomIcon: boolean; // Prop para indicar si es un icono personalizado
}

const IconDisplayBig: FC<IconDisplayProps> = ({ onClick, iconImage, label, isReadOnly, isCustomIcon }) => (
  <Tooltip disableInteractive title={t('select_symbol')} placement="top">
    <FormControl
      variant="outlined"
      className="icon-display-big"
      sx={{
        width: '100%',
      }}
    >
      {label && (
        <FormLabel
          component="legend"
          sx={{
            fontSize: '0.6rem',
            fontWeight: 'bold',
            position: 'absolute',
            color: '#767676',
            top: -8,
            left: 5,
            textShadow:
              '2px 0 15px #fff, -2px 0 5px #fff, 0 2px 5px #fff, 0 -2px 5px #fff, 1px 1px 5px #fff, -1px -1px 5px #fff, 1px -1px 5px #fff, -1px 1px 10px #fff',
            padding: '0 0.2rem 0rem 0.2rem',
            zIndex: 1,
          }}
        >
          {label}
        </FormLabel>
      )}
      <Button
        variant="outlined"
        disabled={isReadOnly}
        onClick={onClick}
        sx={{
          minWidth: '0px',
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          paddingRight: '5px',
          flex: 1,
          width: '100%',
          height: '3rem',
          borderColor: 'rgba(0, 0, 0, 0.23)',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            width: '2.3rem',
            height: '2.3rem',
            marginRight: '5px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: iconImage ? 'none' : '1px solid #acacac',
            backgroundColor: iconImage ? 'none' : 'white',
            borderRadius: '0.3rem',
            overflow: 'hidden',
            position: 'relative',
            '&::after': {
              content: iconImage ? 'none' : '""',
              position: 'absolute',
              left: '0',
              top: '0',
              width: '100%',
              height: '100%',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundImage: iconImage
                ? 'none'
                : `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='1 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cline x1='1' y1='20' x2='20' y2='1' stroke='red' stroke-width='1'/%3E%3C/svg%3E")`,
            },
          }}
        >
          <Box
            sx={{
              width: '2.3rem',
              height: '2.3rem',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              backgroundSize: 'contain',
              zIndex: 1,
              backgroundImage: iconImage ? `url(${iconImage})` : 'none',
            }}
          />
        </Box>
        <Iconify icon="eva:arrow-ios-downward-fill" width={18} />
      </Button>
    </FormControl>
  </Tooltip>
);

export default IconDisplayBig;
